<template>
  <div class="pg-launch"></div>
</template>
<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import Prize from "~/components/Prize/index.vue";
import { isWeiXin, getParameterByName, isAndroid } from "~/tools/utils";
import api from "~/api/api";
import { mapState } from "vuex";
import Alert from "~/components/Alert";

export default {
  components: {Prize},
  data() {
    return {
      isAndroid: isAndroid(),
      loading: false,
      url: getParameterByName("url")
    }
  },
  mounted() {
    const _this = this;
    store.commit(types.SHOW_LOADING, true);
    if(this.url) {
      location.href = this.url
    }
    setTimeout(() => {
      store.commit(types.SHOW_LOADING, false);
      store.commit(types.SHOW_MODAL, {type: 'copy', copy: 'https://yszt.ztgame.com/act/blc_carnival2024/#/index'})
    }, 2000)
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    })
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
  .pg-launch
    width 100%
    min-height 100vh
    background url('./images/bg2.png')
    background-size cover
    .prize-wrapper
      margin 1.26rem 0 0 0.58rem;
      display flex
      flex-wrap wrap
    .bg
      position absolute
      top 0
      height: 8.82rem
      width 100%
      background url('./images/friend-bg.png')
      background-size 100% 100%
    .logo
      position absolute
      top 0.2rem
      left 0.12rem
      width 1.23rem
      height 1.14rem
      background:url(./images/logo.png) no-repeat;
      background-size contain
    .scroll
      position absolute
      top 1.34rem
      left 4.46rem
      width 0.65rem
      height 3.33rem
      background:url(./images/scroll.png) no-repeat;
      background-size contain
      font-size 0.25rem
      color: #a02825
      // writing-mode vertical-rl
      line-height 0.27rem
      text-align center
      letter-spacing 0.01rem
      font-weight bold
      word-break break-all
      display flex
      flex-direction column
      justify-content center
      align-items center
      padding: 0 0.2rem
    .slogan
      position absolute
      top 1.44rem
      left 5.3rem
      width 1.3rem
      height 3.17rem
      background:url(./images/friend-slogan.png) no-repeat;
      background-size contain
      animation slideInRight 0.6s ease
    .human
      position absolute
      top 0.16rem
      left 3.28rem
      width 4.22rem
      height 5.47rem
      background:url(./images/human.png) no-repeat;
      background-size contain
    .friend
      position absolute
      top 5.85rem
      left 0.32rem
      width 6.86rem
      height 5.01rem
      background:url(./images/friend-prize.png) no-repeat;
      background-size contain
    .help
      position absolute
      top 5.62rem
      left 1.15rem
      width 2.36rem
      height 0.8rem
      background:url(./images/help.png) no-repeat;
      background-size contain
    .draw
      position absolute
      left 4rem
      top 5.62rem
      width 2.36rem
      height 0.8rem
      background:url(./images/me.png) no-repeat;
      background-size contain
    .btn-download
      position absolute
      top 0.2rem
      left 4.05rem
      width 2.92rem
      height 1.05rem
      background:url(./images/download.png) no-repeat;
      background-size contain
@keyframes rotate {
  to {
    transform: rotateY(360deg)
  }
}
@keyframes rotate {
  to {
    transform: rotateY(360deg)
  }
}
@keyframes slideInRight {
  0% {
    opacity: 0
    transform: translateX(100%)
  }

  100% {
    opacity: 1
    transform: translateX(0)
  }
}
</style>
